const DEFAULT_LEAD_SETTINGS = {
  // Course Details
  course: { show: true, label: 'Course', mandatory: true },
  branch: { show: true, label: 'Branch', mandatory: true },
  batch: { show: true, label: 'Batch', mandatory: false },
  subjects: { show: true, label: 'Subjects', mandatory: false },

  // Student Details
  studentName: { show: true, label: 'Name', mandatory: true },
  birthDate: { show: true, label: 'D.O.B.', mandatory: false },
  mobile: { show: true, label: 'Mobile', mandatory: true },
  email: { show: true, label: 'Email', mandatory: false },
  gender: { show: true, label: 'Gender', mandatory: false },
  landline: { show: false, label: 'Landline', mandatory: false },
  address: { show: true, label: 'Address', mandatory: false },
  remark: { show: true, label: 'Remark', mandatory: false },

  // Guardian Details
  guardianName: { show: true, label: 'Name', mandatory: true },
  guardianEmail: { show: false, label: 'Email ID', mandatory: false },
  guardianMobile: { show: true, label: 'Mobile', mandatory: true },
  guardianLandline: { show: false, label: 'Landline', mandatory: false },
  occupation: { show: true, label: 'Occupation', mandatory: false },
  income: { show: false, label: 'Income', mandatory: false },

  // School/College Details
  schoolCollege: { show: true, label: 'School', mandatory: false },
  board: { show: true, label: 'Board', mandatory: false },
  courseStd: { show: true, label: 'Course', mandatory: false },
  marks: { show: true, label: 'Marks', mandatory: false },
  status: { show: true, label: 'Status', mandatory: false },
  medium: { show: true, label: 'Medium', mandatory: false },
}

function getStoredSettings() {
  try {
    const raw = localStorage.getItem('cloud_lead_settings')
    if (!raw) {
      localStorage.setItem('cloud_lead_settings', JSON.stringify(DEFAULT_LEAD_SETTINGS))
      return DEFAULT_LEAD_SETTINGS
    }
    return JSON.parse(raw)
  } catch {
    return DEFAULT_LEAD_SETTINGS
  }
}

function saveStoredSettings(settings) {
  try {
    localStorage.setItem('cloud_lead_settings', JSON.stringify(settings))
    window.dispatchEvent(new Event('cloud-lead-updated'))
  } catch (err) {
    console.error('Failed to save lead settings to localStorage', err)
  }
}

export async function fetchLeadSettings() {
  await new Promise((resolve) => setTimeout(resolve, 80))
  return getStoredSettings()
}

export async function saveLeadSettings(payload) {
  await new Promise((resolve) => setTimeout(resolve, 150))
  saveStoredSettings(payload)
  return payload
}

export async function resetLeadSettings() {
  await new Promise((resolve) => setTimeout(resolve, 100))
  saveStoredSettings(DEFAULT_LEAD_SETTINGS)
  return DEFAULT_LEAD_SETTINGS
}
